<template>
  <section id="cost-project" class="cost-project">
    <h1>{{ $t('DStudioCostTitle') }}</h1>
    <div class="body">
      <UiBlocksWithPriceUiAccordionVertical
        :items="accordionItems"
        ref="videoFirstRef"
        @chooseItem="actionHandler"
      />
    </div>
    <ui-button
      class="cost-project__btn"
      @click="actionHandler"
      :color="'primary-offer'"
      :size="ButtonSizeType.b_l"
    >
      {{ $t('orderDesign') }}
    </ui-button>
  </section>
</template>

<script setup lang="ts">
import {ButtonSizeType} from '~/interfaces/ui/button';
import {useDesignStudioStore} from '~/store/design-studio.store';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const designStudio = useDesignStudioStore();
const route = useRoute();
const emits = defineEmits(['designRequest']);

const actionHandler = () => {
  if (route.path.includes('d-studio')) {
    designStudio.btnCreateHandlerForLanding();
  } else {
    emits('designRequest');
  }
};

const accordionItems = [
  {
    id: 1,
    img: `${staticUrl}/images/design-studio/ds-accordion-2-item-1.webp`,
    title: 'DStudioItem1',
    subtitle: 'DStudioItem1Price',
    hiddenTextTitleForLi: 'DStudioItem1HiddenTextTitle',
    hiddenText: [
      'DStudioItem1HiddenTextLi1',
      'DStudioItem1HiddenTextLi2',
      'DStudioItem1HiddenTextLi3',
      'DStudioItem1HiddenTextLi4',
      'DStudioItem1HiddenTextLi5',
    ],
  },
  {
    id: 2,
    img: `${staticUrl}/images/design-studio/ds-accordion-2-item-2.webp`,
    title: 'DStudioItem2',
    subtitle: 'DStudioItem2Price',
    hiddenTextTitleForLi: 'DStudioItem1HiddenTextTitle',
    hiddenText: [
      'DStudioItem2HiddenTextLi1',
      'DStudioItem2HiddenTextLi2',
      'DStudioItem2HiddenTextLi3',
      'DStudioItem2HiddenTextLi4',
      'DStudioItem2HiddenTextLi5',
    ],
  },
  {
    id: 3,
    img: `${staticUrl}/images/design-studio/ds-accordion-2-item-3.webp`,
    title: 'DStudioItem3',
    subtitle: 'DStudioItem3Price',
    hiddenTextTitleForLi: 'DStudioItem1HiddenTextTitle',
    hiddenText: [
      'DStudioItem3HiddenTextLi1',
      'DStudioItem3HiddenTextLi2',
      'DStudioItem3HiddenTextLi3',
      'DStudioItem3HiddenTextLi4',
      'DStudioItem3HiddenTextLi5',
    ],
  },
  {
    id: 4,
    img: `${staticUrl}/images/design-studio/ds-accordion-2-item-4.webp`,
    title: 'DStudioItem4',
    subtitle: 'DStudioItem4Price',
    hiddenTextTitleForLi: 'DStudioItem1HiddenTextTitle',
    hiddenText: [
      'DStudioItem4HiddenTextLi1',
      'DStudioItem4HiddenTextLi2',
      'DStudioItem4HiddenTextLi3',
      'DStudioItem4HiddenTextLi4',
      'DStudioItem4HiddenTextLi5',
    ],
  },
  {
    id: 5,
    img: `${staticUrl}/images/design-studio/ds-accordion-2-item-5.webp`,
    title: 'DStudioItem5',
    subtitle: 'DStudioItem5Price',
    hiddenTextTitleForLi: 'DStudioItem1HiddenTextTitle',
    hiddenText: [
      'DStudioItem5HiddenTextLi1',
      'DStudioItem5HiddenTextLi2',
      'DStudioItem5HiddenTextLi3',
      'DStudioItem5HiddenTextLi4',
      'DStudioItem5HiddenTextLi5',
    ],
  },
];
</script>

<style scoped lang="scss">
.cost-project {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: $m-45;

  &__btn {
    margin: auto;
    margin-top: $m-10;
    max-width: fit-content;
    width: 100%;
    margin-bottom: $m-40;

    @media (max-width: $md) {
      margin-bottom: $m-25;
    }
  }

  .body {
    margin-top: $m-12;

    @media (max-width: $md) {
      margin-top: $m-3;
    }
  }

  @media (min-width: 2000px) {
    min-height: unset;
  }
  @media (max-width: $lg) {
    width: 100%;
  }
  @media (max-width: $md) {
    gap: $g-5;
    margin-top: $m-40;
  }

  h1 {
    @include title-fw-700-fs-56-black-100;
    margin: 0px;
  }
}
</style>
